import axios from "axios";
import CustomInterceptors from "@/api/GAInterceptors";

const instanceMasterData = axios.create({  
  baseURL: process.env.VUE_APP_MASERTDATA_API
});

instanceMasterData.interceptors.request.use(CustomInterceptors.GAInterceptors);

instanceMasterData.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default instanceMasterData;
